import { render, staticRenderFns } from "./m-edit-select-organization-owned-endpoint.vue?vue&type=template&id=e9fad336&scoped=true&"
import script from "./m-edit-select-organization-owned-endpoint.vue?vue&type=script&lang=js&"
export * from "./m-edit-select-organization-owned-endpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fad336",
  null
  
)

export default component.exports